import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import * as firebaseui from 'firebaseui'

const firebaseConfig = {
  apiKey: 'AIzaSyD8MP48wyCv2cTGDTUvzNz8kzlJk0gwl3U',
  authDomain: 'rad-dash.firebaseapp.com',
  projectId: 'rad-dash'
}

firebase.initializeApp(firebaseConfig)
const auth = firebase.auth()
const ui = new firebaseui.auth.AuthUI(auth)

export { firebase, auth, ui }
